<template>
  <div>
    <top-bar voltar="admin/colaboradores"/>
    <menu-dash/>
    <div class="w3-main" style="margin-left:300px;margin-top:50px;">
      <formulario :editar="false"/>
    </div>
  </div>
</template>

<script>
  import TopBar from "../../commons/TopBar.vue"
  import MenuDash from "../../commons/MenuDash.vue"
  import Formulario from "../../admin/colaborador/Formulario"

  export default {
    components: {TopBar, MenuDash, Formulario},
    data() {
      return {}
    },

    methods: {
    },
  }
</script>

<style scoped>
  .w3-centered tr td {
    padding: 13px;
  }

  .w3-table td {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/colaborador/AdminColaboradorCadastrar.vue